import React from "react";
import Select, { type SelectOption, type SelectOptions, type SelectProps } from "../Select/Select";

export interface MultiSelectProps extends Omit<SelectProps, "value" | "onValueChange"> {
  value?: string[];
  onValueChange?: (value: string[]) => void;
  options: SelectOptions;
}

const collectOptions = (options: SelectOptions, outMap: Map<string, SelectOption>) => {
  for (const option of options) {
    if ("options" in option) {
      collectOptions(option.options, outMap);
    } else {
      outMap.set(option.value, option);
    }
  }
};

const withSelectedValues = (options: SelectOptions, values: string[]) => {
  const map = new Map<string, SelectOption>();
  collectOptions(options, map);
  for (const value of values) {
    if (!map.has(value)) {
      map.set(value, { value, label: value });
    }
  }
  return [ ...map.values() ] as SelectOptions;
};

const MultiSelect = ({ value = [], options, onValueChange, onChange, ...props }: MultiSelectProps) => {
  const resolvedOptions = React.useMemo(() => withSelectedValues(options, value), [ options, value ]);

  // @ts-ignore
  const resolvedValue = resolvedOptions.filter(option => value.includes(option.value));

  return (
    <Select
      {...props}
      options={resolvedOptions}
      value={resolvedValue as any}
      // @ts-ignore
      isMulti={true}
      onChange={() => {
      }}
      onValueChange={(nextRaw) => {
        let newValue: any;
        if (Array.isArray(nextRaw)) {
          newValue = (nextRaw.map((item) => typeof item === "string" ? item : item.value));
        } else if (nextRaw) {
          newValue = ([ ...value, nextRaw ]);
        }
        console.log(nextRaw);
        if (newValue) {
          onValueChange?.(newValue);
          onChange?.({ target: { value: newValue } } as any);
        }

        //onValueChange?.([]);
      }}
    />
  );
};

export default MultiSelect;
